import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ContactsPage from "@/pages/ContactsPage";
import ClientsMapPage from "@/pages/ClientsMapPage";
import OpportunitiesPage from "@/pages/OpportunitiesPage";
import CalendarPage from "@/pages/CalendarPage";
import ActivitiesPage from "@/pages/ActivitiesPage";
import TeamPage from "@/pages/TeamPage";
import GoalsPage from "@/pages/GoalsPage";
import CampaignsPage from "@/pages/CampaignsPage";
import SettingsPage from "@/pages/SettingsPage";
import ProductsPage from "@/pages/ProductsPage";
import OrdersPage from "@/pages/OrdersPage";
import RoutesPage from "@/pages/RoutesPage";
import ReportsPage from "@/pages/ReportsPage";
import LocationTrackingPage from "@/pages/LocationTrackingPage";
import VehiclesPage from "@/pages/VehiclesPage";
import ShiftPage from "@/pages/ShiftPage";
import ShiftReportsPage from "@/pages/ShiftReportsPage";
import AdminPage from "@/pages/AdminPage";
import Layout from "@/components/Layout";
import "@/index.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function AppRoutes() {
  const { user } = useAuth();
  
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<DashboardPage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="clients-map" element={<ClientsMapPage />} />
        <Route path="opportunities" element={<OpportunitiesPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="routes" element={<RoutesPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="activities" element={<ActivitiesPage />} />
        <Route path="team" element={<TeamPage />} />
        <Route path="goals" element={<GoalsPage />} />
        <Route path="campaigns" element={<CampaignsPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="location-tracking" element={<LocationTrackingPage />} />
        <Route path="vehicles" element={<VehiclesPage />} />
        <Route path="shift" element={<ShiftPage />} />
        <Route path="shift-reports" element={<ShiftReportsPage />} />
        <Route path="admin" element={<AdminPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
